import { api, ApiRequestConfig } from 'api';
import i18n from 'i18next';

interface IVerificationCodeGenerate {
  phoneNumber: string;
  regionId: string;
}

interface IVerificationCodeGenerateResponse {
  error?: boolean;
  message?: string | null;
}

export const verificationCodeGenerate = async (
  params: IVerificationCodeGenerate,
  config: ApiRequestConfig,
): Promise<IVerificationCodeGenerateResponse> => {
  try {
    await api.post(
      'loyalty-registration-modal/verification-code-generate',
      { phoneNumber: params.phoneNumber, regionId: params.regionId },
      config,
    );

    return {
      error: false,
      message: null,
    };
  } catch (e) {
    const error = e as Error;
    let message = i18n.t('loyalty-registration-modal.generate-phone-step.errors.internal');

    if (error.message?.includes('lifeTime')) {
      message = i18n.t('loyalty-registration-modal.generate-phone-step.errors.lifetime');
    }

    return {
      error: true,
      message,
    };
  }
};
